import NormalBtn from "components/NewButton/NormalBtn";

const ApprovalButtonSet = ({ mode, onClickSave, onClickCancel, onClickMoveToList }) => {
  if (mode === "new" || mode === "edit") {
    return (
      <div style={{ marginTop: "2rem", display: "flex", justifyContent: "center", gap: "0.5rem" }}>
        <NormalBtn theme="white" name="취소" onClick={onClickCancel} />

        <NormalBtn theme="white" name="임시저장" onClick={() => onClickSave("임시저장")} />

        <NormalBtn name="기안" onClick={() => onClickSave("기안")} />
      </div>
    );
  } else {
    return (
      <div style={{ marginTop: "2rem" }}>
        <NormalBtn theme="white" name="목록으로" onClick={onClickMoveToList} />
      </div>
    );
  }
};
export default ApprovalButtonSet;
